
import type { PropType } from 'vue'
import { defineComponent, getCurrentInstance, ref } from 'vue'
import { EpbToggle } from '../../shared/epb-toggle'

export enum ModesEnum {
  TABLE = 'table',
  GRAPH = 'graph',
}

export default defineComponent({
  name: 'ToolReportingToggle',
  components: {
    EpbToggle,
  },
  props: {
    value: {
      type: String as PropType<ModesEnum>,
      default: ModesEnum.GRAPH,
    },
  },
  setup(props) {
    const {
      proxy: { $epb },
    } = getCurrentInstance()

    const messages = $epb.messages.insights.toolReporting
    const toggleOptions = [
      { id: ModesEnum.GRAPH, content: messages.toggle[ModesEnum.GRAPH] },
      { id: ModesEnum.TABLE, content: messages.toggle[ModesEnum.TABLE] },
    ]

    const mode = ref(props.value)

    return {
      baseClass: 'epb-tool-reporting-toggle',
      mode,
      toggleOptions,
    }
  },
})
